<ng-container *ngIf="modalData">
  <section class="protection-details-upsell-modal">
    <ng-container
      *ngIf="
        modalData.annualPlansEnabled &&
          modalData.registeredItemHasAnnualPayment;
        else subscriptionTitle
      "
    >
      <h1 class="protection-details-upsell-modal__title">
        {{ 'PROTECTION_DETAILS_MODAL_TITLE_LAST_CHANCE' | translate }}
      </h1>
    </ng-container>

    <ng-template #subscriptionTitle>
      <h1 class="protection-details-upsell-modal__title">
        <ng-container
          *ngIf="modalData.hasDiscountPrice; else promotionInactive"
        >
          {{ 'PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE_MODAL' | translate }}
        </ng-container>
        <ng-template #promotionInactive>
          {{
            modalData.cmsProtectionDetailsUpsellModal
              .protectionDetailsModalTitle
          }}
        </ng-template>
      </h1>
    </ng-template>

    <dgx-components-rich-text
      [content]="
        modalData.cmsProtectionDetailsUpsellModal.protectionDetailsModalSubtitle
      "
      class="protection-details-upsell-modal__subtitle py-5"
    />

    <dgx-components-panel
      [border]="false"
      [rounded]="'lg'"
      [spacing]="'md'"
      [variant]="'background-alternative'"
    >
      <h2 class="protection-details-upsell-modal__benefits-list-title pb-5">
        {{
          modalData.cmsProtectionDetailsUpsellModal
            .protectionDetailsModalBenefitsListTitle
        }}
      </h2>

      <dgx-components-benefits-list
        [benefits]="benefits"
        [iconSize]="'sm'"
        [theme]="'background-alternative'"
        class="protection-details-upsell-modal__benefits-list"
      />
    </dgx-components-panel>

    <ng-container
      *ngIf="
        modalData.annualPlansEnabled &&
          modalData.registeredItemHasAnnualPayment;
        else monthlySubscription
      "
    >
      <ng-container *ngIf="modalData.hasDiscountPrice">
        <p class="protection-details-upsell-modal__quote-offer mt-6">
          {{
            'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
              | translate
                : {
                    brandName: modalData.merchandiseBrand
                  }
          }}
          <span
            class="protection-details-upsell-modal__price-strikethrough pr-1"
          >
            {{
              modalData.registeredItemAnnualProductDetails?.price
                | currencyFormat
            }}
          </span>
          {{
            modalData.registeredItemAnnualProductDetails?.discountedPrice
              | currencyFormat
          }}
          for 12 months
        </p>

        <p
          class="protection-detail-upsell-modal__cancel-anytime-annual text--center pt-2"
        >
          {{ 'PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL' | translate }}
        </p>
      </ng-container>

      <ng-container *ngIf="!modalData.hasDiscountPrice">
        <p class="protection-details-upsell-modal__quote-offer mt-6">
          {{
            'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
              | translate
                : {
                    brandName: modalData.merchandiseBrand
                  }
          }}
          {{ modalData.prepayPrice | currencyFormat }}
          for 12 months
        </p>

        <p
          class="protection-detail-upsell-modal__cancel-anytime-annual text--center pt-2"
        >
          {{ 'PROTECTION_DETAILS_CANCEL_ANYTIME_ANNUAL' | translate }}
        </p>
      </ng-container>

      <dgx-components-grid-row class="pt-4">
        <dgx-components-grid-column
          *ngFor="let item of modalData.protectionDetailsPaymentOptions"
          [md]="6"
          class="protection-details-upsell-modal__purchase-price-option-column"
        >
          <us-registration-protection-details-purchase-price-option-wib
            (buttonClicked)="handleModalPaymentOptionAction($event)"
            [badgeText]="
              item.paymentFrequency === 'monthly'
                ? ('PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_MONTHLY'
                  | translate)
                : ('PROTECTION_DETAILS_PROMOTIONAL_BADGE_TITLE_ANNUALLY'
                  | translate)
            "
            [buttonLoading]="ctaUpsellLoading"
            [buttonText]="
              'PROTECTION_DETAILS_PURCHASE_PRICE_OPTION_CTA'
                | translate
                  : {
                      monthlyOrAnnual:
                        item | registeredItemMonthlyOrAnnuallyLabel
                    }
            "
            [discountedPrice]="
              item.paymentFrequency === 'monthly'
                ? (modalData.subscriptionPrice
                  | quoteOfferPriceDiscounted : 0.5
                  | currencyFormat)
                : (modalData.prepayPrice | currencyFormat)
            "
            [hasDiscountPrice]="modalData.hasDiscountPrice"
            [newMessage]="'PROTECTION_DETAILS_NEW_MESSAGE' | translate"
            [originalPrice]="
              item.paymentFrequency === 'monthly'
                ? (modalData.subscriptionPrice | currencyFormat)
                : (modalData.prepayPrice | currencyFormat)
            "
            [paymentFrequency]="item.paymentFrequency"
            [subscription]="modalData.discountContent?.subscription"
          />
        </dgx-components-grid-column>
      </dgx-components-grid-row>

      <div class="protection-details-upsell-modal__reg-only-container pt-2">
        <dgx-components-button-text
          (clicked)="continueWithRegistrationOnly()"
          [dgxGaClick]="{
            pagename: 'protection-details-upsell-popup',
            eventCategory: 'modalUpsell',
            eventAction: 'modal-clicked',
            eventLabel: 'No thanks'
          }"
          [underline]="true"
          [underlineNeutral]="true"
        >
          {{ 'PROTECTION_DETAILS_REGISTER_WITHOUT_COVER_CTA' | translate }}
        </dgx-components-button-text>
      </div>
    </ng-container>

    <!-- Monthly Subscription -->

    <ng-template #monthlySubscription>
      <p
        *ngIf="modalData.hasDiscountPrice"
        class="protection-details-upsell-modal__do-not-miss-out pt-5"
      >
        {{ 'PROTECTION_DETAILS_PROMOTIONAL_OFFERS_TITLE' | translate }}
      </p>

      <p
        *ngIf="modalData.hasDiscountPrice"
        class="protection-details-upsell-modal__quote-offer mt-3"
      >
        {{
          'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
            | translate
              : {
                  brandName: modalData.merchandiseBrand
                }
        }}
        for
        <span class="protection-details-upsell-modal__price-strikethrough pr-1"
          >{{ modalData.registeredItemProductPriceDetails | currencyFormat }}
        </span>
        <span>{{
          modalData.subscriptionPrice
            | quoteOfferPriceDiscounted : 0.5
            | currencyFormat
        }}</span>
        a month
      </p>

      <p
        *ngIf="!modalData.hasDiscountPrice"
        class="protection-details-upsell-modal__quote-offer mt-6"
      >
        {{
          'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
            | translate
              : {
                  brandName: modalData.merchandiseBrand
                }
        }}
        {{
          'PROTECTION_DETAILS_QUOTE_OFFER_PRICE'
            | translate
              : {
                  quotePayment: modalData.subscriptionPrice | currencyFormat
                }
        }}
      </p>

      <p class="text--center">
        {{ 'PROTECTION_DETAILS_CANCEL_ANYTIME_MONTHLY' | translate }}
      </p>

      <div class="protection-details-upsell-modal__ctas-container pt-2">
        <div class="protection-details-upsell-modal__ctas">
          <dgx-components-button
            (clicked)="continueWithExtraProtection()"
            [dgxGaClick]="{
              pagename: 'protection-details-upsell-popup',
              eventCategory: 'modalUpsell',
              eventAction: 'modal-clicked',
              eventLabel: 'Register with extra coverage'
            }"
            [fill]="true"
            [loading]="ctaUpsellLoading"
            [variant]="'primary'"
            class="my-4"
          >
            <span class="protection-details-upsell-modal__cta-extend">
              {{
                'PROTECTION_ADDITIONAL_QUOTE_MODAL_EXTEND_BUTTON' | translate
              }}
            </span>
          </dgx-components-button>

          <dgx-components-button
            (clicked)="continueWithRegistrationOnly()"
            [dgxGaClick]="{
              pagename: 'protection-details-upsell-popup',
              eventCategory: 'modalUpsell',
              eventAction: 'modal-clicked',
              eventLabel: 'No thanks'
            }"
            [fill]="true"
            [variant]="'secondary'"
          >
            <span class="protection-details-upsell-modal__cta-no-extend">
              {{
                'PROTECTION_ADDITIONAL_QUOTE_MODAL_NOT_EXTEND_BUTTON'
                  | translate
              }}
            </span>
          </dgx-components-button>
        </div>
      </div>
    </ng-template>
  </section>
</ng-container>
